import React from "react";
import {
  Box,
  Text,
  HStack,
  Button,
  VStack,
  Badge,
  Divider,
  Icon,
} from "@chakra-ui/react";
import { BsBuilding } from "react-icons/bs";

const EstateList = ({
  estates = [],
  onSelectEstate = () => {},
  isVtu = false,
  onSelectVtu = () => {},
  buttonLabel = "Continue",
  activeAccount = null,
}) => {
  const isVtuActive = activeAccount?.type === "vtu";

  return (
    <VStack spacing={0} align="stretch" w="100%">
      {/* Scrollable estate list */}
      {estates.length > 0 ? (
        <>
          <Text
            fontSize="xs"
            fontWeight="semibold"
            color="gray.400"
            textTransform="uppercase"
            letterSpacing="wide"
            mb={2}
          >
            Estates
          </Text>
          <Box
            maxH="200px"
            overflowY="auto"
            pr={1}
            css={{
              "&::-webkit-scrollbar": { width: "4px" },
              "&::-webkit-scrollbar-track": { background: "transparent" },
              "&::-webkit-scrollbar-thumb": {
                background: "#CBD5E0",
                borderRadius: "4px",
              },
            }}
          >
            <VStack spacing={2} align="stretch">
              {estates.map((e) => {
                const estate = e?.estateId || e;
                const id = estate?._id || estate;
                const name = estate?.estateName || estate?.name || String(id);
                const isActive =
                  activeAccount?.type === "estate" &&
                  String(activeAccount?.estateId) === String(id);

                return (
                  <HStack key={String(id)} justify="space-between" py={1}>
                    <Box>
                      <Text fontWeight="semibold" fontSize="sm">
                        {name}
                      </Text>
                      <Text fontSize="xs" color="gray.500">
                        {e?.role || "Member"}
                      </Text>
                    </Box>
                    <HStack>
                      {isActive && (
                        <Badge colorScheme="blue" fontSize="xs">
                          Active
                        </Badge>
                      )}
                      <Button
                        onClick={() => onSelectEstate(e)}
                        colorScheme={isActive ? "green" : "gray"}
                        size="sm"
                      >
                        {buttonLabel}
                      </Button>
                    </HStack>
                  </HStack>
                );
              })}
            </VStack>
          </Box>
        </>
      ) : (
        <Box
          py={6}
          px={4}
          textAlign="center"
          bg="gray.50"
          borderRadius="10px"
          border="1px dashed"
          borderColor="gray.200"
          mb={isVtu ? 3 : 0}
        >
          <Icon as={BsBuilding} boxSize={6} color="gray.300" mb={2} />
          <Text fontSize="sm" fontWeight="semibold" color="gray.500">
            No estates joined yet
          </Text>
          <Text fontSize="xs" color="gray.400" mt={1}>
            Accept an invitation to join an estate.
          </Text>
        </Box>
      )}

      {/* VTU section — separated by a divider */}
      {isVtu && (
        <>
          <Box my={3}>
            <Divider />
            <Text
              fontSize="xs"
              fontWeight="semibold"
              color="gray.400"
              textTransform="uppercase"
              letterSpacing="wide"
              mt={3}
              mb={2}
            >
              Other Accounts
            </Text>
          </Box>

          <HStack justify="space-between" py={1}>
            <Box>
              <Text fontWeight="semibold" fontSize="sm">
                VTU Account
              </Text>
              <Text fontSize="xs" color="gray.500">
                Airtime, data, bills &amp; more
              </Text>
            </Box>
            <HStack>
              {isVtuActive && (
                <Badge colorScheme="blue" fontSize="xs">
                  Active
                </Badge>
              )}
              <Button
                onClick={onSelectVtu}
                colorScheme={isVtuActive ? "green" : "gray"}
                size="sm"
              >
                {buttonLabel}
              </Button>
            </HStack>
          </HStack>
        </>
      )}
    </VStack>
  );
};

export default EstateList;
